import { render, staticRenderFns } from "./scheduling.vue?vue&type=template&id=63b41cb4&scoped=true&"
import script from "./scheduling.vue?vue&type=script&lang=js&"
export * from "./scheduling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b41cb4",
  null
  
)

export default component.exports